module.exports = __webpack_public_path__ + "static/media/medford-small-placeholder.1ea68b4a.webp";